/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    baseUrl = "v1";
    securityData = null;
    securityWorker;
    abortControllers = new Map();
    customFetch = (...fetchParams) => fetch(...fetchParams);
    baseApiParams = {
        credentials: "same-origin",
        headers: {},
        redirect: "follow",
        referrerPolicy: "no-referrer",
    };
    constructor(apiConfig = {}) {
        Object.assign(this, apiConfig);
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    contentFormatters = {
        [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
        [ContentType.Text]: (input) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
        [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === "object" && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData()),
        [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
    };
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createAbortSignal = (cancelToken) => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }
        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };
    abortRequest = (cancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);
        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };
    request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;
        return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone();
            r.data = null;
            r.error = null;
            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                    .then((data) => {
                    if (r.ok) {
                        r.data = data;
                    }
                    else {
                        r.error = data;
                    }
                    return r;
                })
                    .catch((e) => {
                    r.error = e;
                    return r;
                });
            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }
            if (!response.ok)
                throw data;
            return data;
        });
    };
}
/**
 * @title Permits Service
 * @version 1.0.0
 * @baseUrl v1
 *
 * Product API for Permits
 */
export class Api extends HttpClient {
    permits = {
        /**
         * @description Create an inspection for the permit with the given id
         *
         * @name InspectionCreate
         * @request POST:/permits/{id}/inspection
         */
        inspectionCreate: (id, data, params = {}) => this.request({
            path: `/permits/${id}/inspection`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Creates a new inspection for the given workflow step of the given permit
         *
         * @name StepsInspectionCreate
         * @request POST:/permits/{id}/steps/{stepId}/inspection
         */
        stepsInspectionCreate: (id, stepId, params = {}) => this.request({
            path: `/permits/${id}/steps/${stepId}/inspection`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * @description Event endpoint for when an inspection is requested
         *
         * @name InspectionsRequestedCreate
         * @request POST:/permits/{id}/inspections/{inspection_id}/requested
         */
        inspectionsRequestedCreate: (id, inspectionId, params = {}) => this.request({
            path: `/permits/${id}/inspections/${inspectionId}/requested`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * @description Create permit charges for the permit with the given id
         *
         * @name ChargesCreate
         * @request POST:/permits/{id}/charges
         */
        chargesCreate: (id, data, params = {}) => this.request({
            path: `/permits/${id}/charges`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create permit charges for the permit with the given id
         *
         * @name TransactionsCreate
         * @request POST:/permits/{id}/transactions
         */
        transactionsCreate: (id, data, params = {}) => this.request({
            path: `/permits/${id}/transactions`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Updates the status of the transaction with the given id to pending
         *
         * @name PendingCreate
         * @request POST:/permits/{id}/pending
         */
        pendingCreate: (id, params = {}) => this.request({
            path: `/permits/${id}/pending`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * @description Create permit attachments for the permit with the given id
         *
         * @name AttachmentsCreate
         * @request POST:/permits/{id}/attachments
         */
        attachmentsCreate: (id, data, params = {}) => this.request({
            path: `/permits/${id}/attachments`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Lists all of the attachments for the permit with the given id
         *
         * @name AttachmentsDetail
         * @request GET:/permits/{id}/attachments
         */
        attachmentsDetail: (id, params = {}) => this.request({
            path: `/permits/${id}/attachments`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Deletes the attachment with the given attachment-id for the permit with the given id
         *
         * @name AttachmentsDelete
         * @request DELETE:/permits/{id}/attachments/{attachmentId}
         */
        attachmentsDelete: (id, attachmentId, params = {}) => this.request({
            path: `/permits/${id}/attachments/${attachmentId}`,
            method: "DELETE",
            ...params,
        }),
        /**
         * @description Gets a permit by id (if it exists) otherwise an error is returned
         *
         * @name PermitsDetail
         * @request GET:/permits/{id}
         */
        permitsDetail: (id, params = {}) => this.request({
            path: `/permits/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Gets a permit-type by id (if it exists) otherwise an error is returned
         *
         * @name TypesDetail
         * @request GET:/permits/types/{id}
         */
        typesDetail: (id, query, params = {}) => this.request({
            path: `/permits/types/${id}`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the permit-type by id (if its exists)
         *
         * @name TypesUpdate
         * @request PUT:/permits/types/{id}
         */
        typesUpdate: (id, data, params = {}) => this.request({
            path: `/permits/types/${id}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets a permit-form by id (if it exists) otherwise an error is returned
         *
         * @name FormsDetail
         * @request GET:/permits/forms/{id}
         */
        formsDetail: (id, params = {}) => this.request({
            path: `/permits/forms/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Gets a permits fee by id (if it exists) otherwise an error is returned
         *
         * @name FeesDetail
         * @request GET:/permits/fees/{id}
         */
        feesDetail: (id, params = {}) => this.request({
            path: `/permits/fees/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Updates a permits fee by id (if it exists) otherwise an error is returned
         *
         * @name FeesUpdate
         * @request PUT:/permits/fees/{id}
         */
        feesUpdate: (id, data, params = {}) => this.request({
            path: `/permits/fees/${id}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Soft deletes a permits fee by id (if it exists) otherwise an error is returned
         *
         * @name FeesDelete
         * @request DELETE:/permits/fees/{id}
         */
        feesDelete: (id, params = {}) => this.request({
            path: `/permits/fees/${id}`,
            method: "DELETE",
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new fee item
         *
         * @name FeesCreate
         * @request POST:/permits/fees
         */
        feesCreate: (data, params = {}) => this.request({
            path: `/permits/fees`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all fee items
         *
         * @name FeesList
         * @request GET:/permits/fees
         */
        feesList: (params = {}) => this.request({
            path: `/permits/fees`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Sends a payment requested email to the permit with the given id
         *
         * @name RequestPaymentCreate
         * @request POST:/permits/request-payment/{id}
         */
        requestPaymentCreate: (id, params = {}) => this.request({
            path: `/permits/request-payment/${id}`,
            method: "POST",
            ...params,
        }),
        /**
         * @description Gets a permit-type by id (if it exists) otherwise an error is returned
         *
         * @name CustomFieldsList
         * @request GET:/permits/custom-fields
         */
        customFieldsList: (query, params = {}) => this.request({
            path: `/permits/custom-fields`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
}
